import { createFileRoute } from "@tanstack/react-router";

import DashboardPage from "@/features/dashboard/pages/dashboard";

// Command Center — the operator home.
export const Route = createFileRoute("/(app)/ops/")({
  component: () => <DashboardPage />,
});
